"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.setOpen = exports.get = void 0;
var imports_1 = require("@lib/imports");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageJsonServerInterface_sidecar_1 = require("@voyage/saver/voyageJsonServerInterface-sidecar");
var voyageShipSaver_sidecar_1 = require("@voyage/saver/voyageShipSaver-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageUiCanvas_sidecar_1 = require("@voyage/ui/voyageUiCanvas-sidecar");
var voyageUiGButtons_sidecar_1 = require("@voyage/ui/voyageUiGButtons-sidecar");
var voyageUiGraphicsUtils_sidecar_1 = require("@voyage/ui/voyageUiGraphicsUtils-sidecar");
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
        exports.setOpen(false);
        updateList(['!']);
        render();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    var tw = 700;
    var th = 800;
    var canvas = voyageUiCanvas_sidecar_1.voyageUiCanvas.create(tw, th, voyageLayers_sidecar_1.voyageLayers.getLayers().uiMenu);
    canvas.ox = 0;
    canvas.oy = 0;
    var obj = voyageUiCanvas_sidecar_1.voyageUiCanvas.assign(canvas, {
        selectedBattle: null,
    });
    return obj;
};
var updateList = function (list) {
    var x = 20;
    var y = 40;
    var obj = get();
    var addButton = function (text, action, onMouseOver) {
        var button = voyageUiGButtons_sidecar_1.voyageUiGButtons.create(text, x, y, action);
        button.onMouseOver = onMouseOver;
        button.w = 200;
        obj.buttons.push(button);
        y += 60;
        if (y > obj.targetHeight - 60) {
            x += 200 + 20;
            y = 40;
        }
    };
    obj.buttons = [];
    imports_1.l.forEach(list, function (c) {
        addButton(c, function () {
            //goatGameModeManager.goProtoBattle()
            // goatGameMode_freeBuild.setFilename(c)
            voyageShipSaver_sidecar_1.voyageShipSaver.load(c);
            exports.setOpen(false);
        }, function () {
            // get().selectedBattle = c
        });
    });
    y += 60;
    addButton('Cancel', function () {
        exports.setOpen(false);
    }, function () { });
};
var render = function () {
    var obj = get();
    var g = obj.graphics;
    voyageUiCanvas_sidecar_1.voyageUiCanvas.clear(obj);
    if (!obj.isOpen) {
        return;
    }
    var addText = function (text, x, y) {
        var _text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font6, x, y, obj.layer);
        stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
        stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 3);
        obj.texts.push(_text);
        return _text;
    };
    var x = 0;
    var y = 0;
    var w = obj.targetWidth;
    var h = obj.targetHeight;
    voyageUiGraphicsUtils_sidecar_1.voyageUiGraphicsUtils.bevelPanel(g, x, y, w, h);
    addText('Load Ship Design', x + 6, y); // + 25 - 2)
    x = 400;
    y = 60;
    // let b = obj.selectedBattle
    // if (b) {
    //   addText(b.name, x, y)
    //   y += 40
    //   addText(b.desc, x, y)
    //   y += 40
    //   addText('Budget: $' + b.budget, x, y)
    // }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.render(obj);
};
var setOpen = function (isOpen) {
    var obj = get();
    if (isOpen && !obj.isOpen) {
        voyageJsonServerInterface_sidecar_1.voyageJsonServerInterface.list(function (list) {
            updateList(list);
        });
    }
    voyageUiCanvas_sidecar_1.voyageUiCanvas.setOpen(obj, isOpen);
    exports.update();
};
exports.setOpen = setOpen;
var update = function () {
    var obj = get();
    voyageUiCanvas_sidecar_1.voyageUiCanvas.update(obj);
    render();
};
exports.update = update;
